<template>
  <div style="padding-bottom: 2rem">
    <van-image class="img" :src="one" @click="service"></van-image>
    <van-image class="img" :src="two"></van-image>
    <XuqiuItem />
    <van-image class="img" :src="four"></van-image>
    <van-image class="img" :src="five"></van-image>
    <van-image class="img" :src="six"></van-image>
    <van-image class="img" :src="seven"></van-image>
    <van-image class="img" :src="eight"></van-image>
    <van-image class="img" :src="nine"></van-image>
    <van-image class="img" :src="ten"></van-image>
    <van-image class="img" :src="eleven"></van-image>
    <van-image class="img" :src="twelve"></van-image>
    <van-image class="img" :src="thirteen"></van-image>
    <XuqiuItem />
    <van-image class="img" :src="fourteen"></van-image>
    <van-image class="img" :src="fifteen"></van-image>
    <van-row
      gutter="20"
      class="xz-BgColor-All"
      style="
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 2rem;
        padding-bottom: 10px;
        padding-top: 10px;
      "
    >
      <van-col span="12" style="padding-left: 10px" @click="service">
        <van-button :icon="kefu" style="width: 100%; border-color: #bf4333">
          咨询客服
        </van-button>
      </van-col>
      <van-col span="12" style="padding-right: 10px" @click="show = true">
        <van-button type="danger" style="width: 100%" color="#BF4333">
          提交需求
        </van-button></van-col
      >
    </van-row>
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <van-icon name="cross" @click="show = false" color="white" style="display:block;padding-right:10%" class="text-r" />
          <XuqiuItem :show="true" style="width:80%;margin-left:10%" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import XuqiuItem from "@/views/enterprise/xuqiuItem";
export default {
  components: {
    XuqiuItem,
  },
  data() {
    return {
      show:false,
      one: require("@/assets/imgs/enterprise/01.png"),
      two: require("@/assets/imgs/enterprise/02.png"),
      four: require("@/assets/imgs/enterprise/04.png"),
      five: require("@/assets/imgs/enterprise/05.png"),
      six: require("@/assets/imgs/enterprise/06.png"),
      seven: require("@/assets/imgs/enterprise/07.png"),
      eight: require("@/assets/imgs/enterprise/08.png"),
      nine: require("@/assets/imgs/enterprise/09.png"),
      ten: require("@/assets/imgs/enterprise/10.png"),
      eleven: require("@/assets/imgs/enterprise/11.png"),
      twelve: require("@/assets/imgs/enterprise/12.png"),
      thirteen: require("@/assets/imgs/enterprise/13.png"),
      fourteen: require("@/assets/imgs/enterprise/14.png"),
      fifteen: require("@/assets/imgs/enterprise/15.png"),
      kefu: require("@/assets/imgs/enterprise/17.png"),
    };
  },
  methods:{
    service(){
      window.location.href = "https://wpa1.qq.com/Z5p1pVqc?_type=wpa&qidian=true";
    }
  }
};
</script>

<style scoped>
.img {
  display: block;
}
 .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
</style>